export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";